import type { FC } from 'react';
import styled from 'styled-components';

import { Button, Flex, Progress, useI18n } from '@pega/cosmos-react-core';

import FeedButton from './FeedButton';
import type { FeedCustomEditRegionProps } from './Feed.types';
import FeedVisibilityControls from './FeedVisibilityControls';

export const StyledActions = styled.div`
  ${FeedButton} + ${FeedButton} {
    margin-inline-start: unset;
  }
`;

const FeedCustomEditRegion: FC<FeedCustomEditRegionProps> = ({
  id,
  banners,
  progress,
  editContent,
  visibility,
  recipients = [],
  recipientInput,
  onEditSubmit,
  onEditCancel
}: FeedCustomEditRegionProps) => {
  const t = useI18n();

  return (
    <Flex container={{ direction: 'column', gap: 2, pad: [0, 5, 0, 0] }}>
      <Flex container={{ direction: 'column', gap: 1 }} inert={progress ? '' : undefined}>
        {banners}

        {visibility === 'private' && !!recipientInput && (
          <FeedVisibilityControls
            visibilityMode='private'
            visibility='private'
            recipientInput={recipientInput}
          />
        )}

        {editContent}

        <Progress
          visible={!!progress}
          focusOnVisible
          placement='local'
          message={typeof progress === 'string' ? progress : undefined}
        />
      </Flex>

      {/* Replace this section with ResponsiveActions component once merged. */}
      <Flex
        as={StyledActions}
        container={{ justify: 'between', alignItems: 'center', wrap: 'wrap', gap: 1 }}
      >
        <Button disabled={!!progress} onClick={() => onEditCancel(id)}>
          {t('cancel')}
        </Button>

        <Button
          variant='primary'
          disabled={!!progress}
          onClick={() =>
            onEditSubmit({
              id,
              visibility,
              recipients: recipientInput?.recipients ?? recipients
            })
          }
        >
          {t('update')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default FeedCustomEditRegion;
